import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { Card, Title, Text, BarChart } from "@tremor/react";
import * as Common from "../../../Components/Common";
import { getBillSummaryData } from "../../../Services/DashboardService";
import { TOAST_MESSAGES } from "../../../Constants/Strings";
import { useDashboard } from "../../../Context";
import TotalBillSummary from "./TotalBillSummary";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";

const BillSummaryChart = () => {
  const [billData, setBillData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const { filters, getFormattedData } = useDashboard();

  const fetchBillData = () => {
    if (filters) {
      getBillSummaryData(getFormattedData()).then((Response) => {
        if (Response.status === 200) {
          setBillData(Response.data);
        } else {
          const msg = extractErrorMessage(Response) || TOAST_MESSAGES.FAILED_lOAD;
          toast.error(msg);
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    if (filters.user_id) {
      fetchBillData();
    } else {
      setLoading(false);
    }
  }, [filters]);

  const formattedData = billData?.map(item => ({
    user: item.user,
    "Approved": item.approved || 0,
    "Pending": item.pending || 0,
    "Rejected": item.rejected || 0,
  }));
  return (
    <Card className="bg-white shadow-xl rounded-xl border-red-100 p-4 overflow-x-auto min-w-full">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="">
          <Title className="text-lg">Bill Amount</Title>
          <Text className="text-sm text-gray-500">User wise bill amount</Text>
        </div>
        <TotalBillSummary />
      </div>

      {loading ? (
        <div className="h-72 flex items-center justify-center">
          <Common.Spinner />
        </div>
      ) : (
        <BarChart
          className="mt-6 h-72"
          data={formattedData || []}
          index="user"
          categories={["Approved", "Pending", "Rejected"]}
          colors={["green-300", "blue-400", "red-400"]}
          showXAxis={true}
          yAxisWidth={80}
          showAnimation={true}
          animationDuration={1000}
          rotateLabelX={{ angle: 0, verticalShift: 10, xAxisHeight: 40 }}
          enableLegendSlider={true}
          valueFormatter={(v) => `₹${v.toLocaleString()}`}
        />
      )}
    </Card>
  );
};
export default BillSummaryChart;
